export function isDesktopDevice() {
  if (typeof window === "undefined") return true;
  const coarsePointer =
    window.matchMedia && window.matchMedia("(pointer: coarse)").matches;
  return window.innerWidth >= 1024 && !coarsePointer;
}
